import { createRouter, createWebHashHistory } from "vue-router";
import Home from '../components/pages/Home.vue'

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
            keepAlive: false
        }
    },
    {
        path: '/signIn',
        name: 'SignIn',
        component: () => import('../components/pages/SignIn.vue')
    },
    {
        path: '/reserve/:id',
        name: 'Reserve',
        component: () => import('../components/pages/Reserve.vue')
    },
    {
        path: '/reserveDone/:id',
        name: 'ReserveDone',
        component: () => import('../components/pages/ReserveDone.vue')
    },
    {
        path: '/member',
        name: 'Member',
        component: () => import('../components/pages/Member.vue')
    },
    {
        path: '/myNumber',
        name: 'MyNumber',
        component: () => import('../components/pages/MyNumber.vue')
    },
    {
        path: '/addMember',
        name: 'AddMember',
        component: () => import('../components/pages/AddMember.vue')
    },
    {
        path: '/signUp',
        name: 'SignUp',
        component: () => import('../components/pages/SignUp.vue')
    },
    {
        path: '/sendOtp',
        name: 'SendOtp',
        component: () => import('../components/pages/SendOtp.vue')
    },
    {
        path: '/verifyOtp/:id',
        name: 'VerifyOtp',
        component: () => import('../components/pages/VerifyOtp.vue')
    },
    {
        path: '/resetPwd/:id/:token',
        name: 'ResetPwd',
        component: () => import('../components/pages/ResetPwd.vue')
    },
    {
        path: '/permBookingCheck',
        name: 'PermBookingCheck',
        component: () => import('../components/pages/PermBookingCheck.vue')
    },
    {
        path: '/permBooking',
        name: 'PermBooking',
        component: () => import('../components/pages/PermBookingDetail.vue')
    
    }
]

const router = createRouter({
    mode: 'hash',
    history: createWebHashHistory(),
    routes
})

router.afterEach((to, from) => {
    console.log(to, from);
    window.scrollTo(0, 0);
    setTimeout(() => { window.scrollTo(0, 0); }, 100);
});

console.log(process.env.VUE_APP_URL)

export default router